import './Footer.css';
import Copyright from '../Copyright/Copyright';

function Footer() {
  return (
    <div className='footer component-layout'>
      <Copyright />
    </div>
  );
}

export default Footer;